module.exports = __webpack_public_path__ + "static/media/bottle.47b9a734.jpeg";